/**
 * How a purchase-order number reads in a sentence. Ewee's Books numbers already start with "PO-": render them alone
 * ("PO-06433"), never "PO PO-06433". A bare number typed by hand ("06433") gets the word. Mirrors
 * `app.purchasing.types.po_text` on the API.
 */
export function poText(number: string | null | undefined): string {
  const text = (number ?? '').trim()
  if (!text) return ''
  return /^PO-/i.test(text) ? text : `PO ${text}`
}
